import { render, staticRenderFns } from "./TradeHistories.vue?vue&type=template&id=1182cfee&scoped=true"
import script from "./TradeHistories.vue?vue&type=script&lang=ts"
export * from "./TradeHistories.vue?vue&type=script&lang=ts"
import style0 from "./TradeHistories.vue?vue&type=style&index=0&id=1182cfee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182cfee",
  null
  
)

export default component.exports